<div class="ml-5">
  <p class="titre1 m-4">
    {{ 'RAPPORT_PARCOURS.TITRE' | translate }}
    <mat-icon class="material-symbols-outlined text-[38px] w-[45px] h-[45px] mt-[5px] mr-[30px] float-right">bar_chart</mat-icon>
  </p>

  <mat-tab-group [(selectedIndex)]="activeTabIndex" animationDuration="0ms" class="rapport-tabs">
    <mat-tab>
      <ng-template mat-tab-label>
        <mat-icon class="mr-1">menu_book</mat-icon>
        {{ 'RAPPORT_PARCOURS.VUE_PARCOURS' | translate }}
      </ng-template>
      <app-vue-parcours (voirDetails)="naviguerVersUtilisateurs($event)"></app-vue-parcours>
    </mat-tab>

    <mat-tab>
      <ng-template mat-tab-label>
        <mat-icon class="mr-1">people</mat-icon>
        {{ 'RAPPORT_PARCOURS.VUE_UTILISATEURS' | translate }}
      </ng-template>
      <app-vue-utilisateurs
        [filtreParcoursFormationId]="filtreParcoursFormationId"
        (reinitialiserNavigation)="reinitialiserFiltresNavigation()"
        (voirDetails)="naviguerVersContenus($event.parcoursFormationId, $event.utilisateurId)">
      </app-vue-utilisateurs>
    </mat-tab>

    <mat-tab>
      <ng-template mat-tab-label>
        <mat-icon class="mr-1">school</mat-icon>
        {{ 'RAPPORT_PARCOURS.VUE_CONTENUS' | translate }}
      </ng-template>
      <app-vue-contenus
        [filtreParcoursFormationId]="filtreParcoursFormationId"
        [filtreUtilisateurId]="filtreUtilisateurId"
        (reinitialiserNavigation)="reinitialiserFiltresNavigation()">
      </app-vue-contenus>
    </mat-tab>
  </mat-tab-group>
</div>
